module.exports = {"222426001":"长兴街道","222426002":"瓮声街道","222426003":"九龙街道","222426100":"明月镇","222426101":"松江镇","222426102":"二道白河镇","222426103":"两江镇","222426104":"石门镇","222426105":"万宝镇","222426106":"亮兵镇","222426120":"长白山保护开发区池北区特殊乡镇","222426200":"新合乡","222426201":"永庆乡","222426400":"白河林业局","222426401":"安图林业有限公司","222426402":"安图县林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222426.json
// module id = 760
// module chunks = 0